import { defineAsyncComponent } from "vue";
import { defineFieldFormInterface } from "~/entities/field";

export default defineFieldFormInterface({
  interface: "list-o2m",
  component: defineAsyncComponent(() => import("./ListO2M.vue")),
});
